package com.hyperether.goodjob.util

class FileUtil {

    fun getFileType(fileId: String): FileType {
        return when {
            fileId.endsWith(".jpeg", ignoreCase = true) ||
                    fileId.endsWith(".jpg", ignoreCase = true) ||
                    fileId.endsWith(".png", ignoreCase = true) -> FileType.Image

            fileId.endsWith(".pdf", ignoreCase = true) -> FileType.PDF
            else -> FileType.Unknown
        }
    }

    fun isImageFile(fileName: String): Boolean {
        return fileName.lowercase().endsWithAny(listOf("png", "jpg", "jpeg"))
    }

    fun String.endsWithAny(extensions: List<String>): Boolean {
        return extensions.any { this.endsWith(it, ignoreCase = true) }
    }
}